import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { Problems } from './components/Problems';
import { SystemIntro } from './components/SystemIntro';
import { Modules } from './components/Modules';
import { Bonuses } from './components/Bonuses';
import { Transformation } from './components/Transformation';
import { Pricing } from './components/Pricing';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { FinalClose } from './components/FinalClose';
import { Footer } from './components/Footer';
import { PurchaseNotifications } from './components/PurchaseNotifications';
import { initMetaPixel, trackPixelEvent, PRODUCT_EVENT_PARAMS } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
    trackPixelEvent('ViewContent', PRODUCT_EVENT_PARAMS);
  }, []);
  return <div className="w-full min-h-full bg-charcoal font-body text-cream" data-id="element-0" data-mp="23ujkecdc1n3i">
      <Hero data-id="element-1" data-mp="3ikh98cxzsz0k" />
      <main data-id="element-2" data-mp="3iiwdwl3utc1n">
        <Problems data-id="element-3" data-mp="3ij65ue8glt9z" />
        <SystemIntro data-id="element-4" data-mp="3ijpdn24eb1aa" />
        <Modules data-id="element-5" data-mp="3mlj9mx3nbh44" />
        <Bonuses data-id="element-6" data-mp="3ml14faz09sk2" />
        <Transformation data-id="element-7" data-mp="3mkhlbqxmcy4g" />
        <Pricing data-id="element-8" data-mp="3mjzpuwis6nxl" />
        <Guarantee data-id="element-9" data-mp="3mjgczu7zmpqf" />
        <Testimonials data-id="element-10" data-mp="3rcj6618urx63" />
        <Faq data-id="element-11" data-mp="3rbzo8kj7d8s2" />
        <FinalClose data-id="element-12" data-mp="3rdkhm6ts6loc" />
      </main>
      <Footer data-id="element-13" data-mp="3reccfffk0fdk" />
      <PurchaseNotifications data-id="element-14" data-mp="5yj0slx59ec" />
    </div>;
}